import { ToolbarStyled, SaveButtonStyled, CancelButtonStyled } from './styled';
import { DefaultToolbarProps } from './types';

const DefaultToolbar = ({
  alwaysEnable = false,
  cancelButtonLabel = 'Cancel',
  disabled,
  onSave,
  onClose,
  renderCancelButton = true,
  renderSaveButton = true,
  saveButtonLabel = 'Save',
  ...props
}: DefaultToolbarProps) => (
  <ToolbarStyled {...props}>
    {renderSaveButton && (
      <SaveButtonStyled alwaysEnable={alwaysEnable} disabled={disabled} label={saveButtonLabel} onClick={onSave} />
    )}
    {renderCancelButton && <CancelButtonStyled onClick={onClose}>{cancelButtonLabel}</CancelButtonStyled>}
  </ToolbarStyled>
);

export default DefaultToolbar;
